// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1s9oR","content":"styles_content__1OXFU","checkbox":"styles_checkbox__3scE5","checkboxLabel":"styles_checkboxLabel__LYq3C"};